module.exports = __webpack_public_path__ + "img/trailerDriving.be39e135.jpg";